import React from 'react';
import './index.css';
import history from 'common/history'
import ImgCard from 'component/imgCard'
import * as util from 'common/util'
class ProBox extends React.Component {
    handleClick(id, type, item) {
      console.log('type',type)
        if (type === 'project') {
            history.push('/courseproject/' + id)
        } else if(type==='live') {
            history.push('/courselive/' + id)
        }else if(type==='experiment'){
            history.push('/courseexper/' + id)
        }
    }
    numParse(num) {
        if (num.toString().length >= 9) {
            return util.spliceNum((num / 100000000).toFixed(3).slice(0,-1),1)
        } else if (num.toString().length >= 5) {
            return util.spliceNum((num / 10000).toFixed(3).slice(0,-1),0)
        }else {
            return num
        }
    }

    render() {
        const { data } = this.props;
        let clicknum = data.click_record_num  || '0';
        clicknum = this.numParse(clicknum);
        let learnnum = data.collect_record_num  || '0';
        learnnum = this.numParse(learnnum)
        return (
            <div className="pro-card" onClick={()=>{this.handleClick(data.id ,data.type ,data)}}>
                <div className="pro-card-top">
                  <ImgCard src={data.thumb ?data.thumb :''} />
                  {data.model == 'require'? <img className='tipImg' src={require('./img/compulsoryCourse.png')} alt="必修课"/>:null}
                  {data.model == 'select'?<img className='tipImg' src={require('./img/electiveCourse.png')} alt="选修课"/>:null}
                </div>
                <div className="pro-card-content">
                  <div className="pro-card-title">
                    <div className="name">{data.title ?data.title :'暂无'}</div>
                  </div>
                  <div className="pro-card-bottom">
                    <div className="card-actions">
                      <div className="card-icon">
                        <img src={require('./img/icon_eye.png')} alt="" />
                      </div>
                      <span>{clicknum}</span>
                    </div>
                    {/*<div className="card-actions">*/}
                      {/*<div className="card-icon">*/}
                        {/*<img src={require('./img/icon_book.png')} alt=""/>*/}
                      {/*</div>*/}
                      {/*<span>{learnnum}人学习</span>*/}
                    {/*</div>*/}
                  </div>
                </div>
              </div>
        )
    }
}
export default ProBox;
